import ContentLoader from 'react-content-loader'

const SectionCardContentLoader = () => {
  return (
    <ContentLoader
      speed={0.75}
      width="100%"
      height={100}
      viewBox="0 0 800 100"
      backgroundColor="#e0e0e0"
      foregroundColor="#ecebeb"
      style={{ width: '100%', height: 'auto' }}
    >
      <rect rx="4" ry="4" width="800" height="100" />
    </ContentLoader>
  )
}

export default SectionCardContentLoader
